import { foundingTradersContent } from '@/config/marketing-content/founding-traders'
import { MarketingCta } from '@/components/marketing/marketing-cta'
import { MarketingHero } from '@/components/marketing/marketing-hero'
import { SectionHeader } from '@/components/marketing/section-header'

export function FoundingTradersPage() {
  return (
    <main>
      <MarketingHero
        className="marketing-hero--compact"
        eyebrow={foundingTradersContent.eyebrow}
        title={foundingTradersContent.heroTitle}
        paragraphs={foundingTradersContent.heroParagraphs}
        ctaLabel={foundingTradersContent.heroCtaLabel}
        ctaHref={foundingTradersContent.heroCtaHref}
      />

      <section className="founding-traders-section">
        <div className="marketing-container space-y-10">
          <h2 className="founding-traders-section__title">
            {foundingTradersContent.benefitsTitle}
          </h2>
          <div className="founding-benefits-grid">
            {foundingTradersContent.benefits.map((benefit) => (
              <article key={benefit.tag} className="founding-benefit-card">
                <h3 className="founding-benefit-card__title">{benefit.tag}</h3>
                <p className="founding-benefit-card__description">{benefit.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="marketing-section founding-trade-section">
        <div className="marketing-container space-y-10">
          <SectionHeader
            eyebrow={foundingTradersContent.tradeEyebrow}
            title={foundingTradersContent.tradeTitle}
            lead={foundingTradersContent.tradeLead}
            align="center"
          />
          <div className="founding-trade-grid">
            {foundingTradersContent.tradeItems.map((item) => (
              <article key={item.title} className="founding-trade-card">
                <h3 className="founding-trade-card__title">{item.title}</h3>
                <p className="founding-trade-card__description">{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <MarketingCta
        title={foundingTradersContent.ctaTitle}
        lead={foundingTradersContent.ctaLead}
        primaryLabel={foundingTradersContent.ctaPrimaryLabel}
        primaryHref={foundingTradersContent.ctaPrimaryHref}
      />
    </main>
  )
}
